const styles = (theme) => ({
    root: {
        width: '80%',
        marginBottom: 36,
    },
});

export default styles;
